import { useUserStore } from "~/store/user";

export default defineNuxtRouteMiddleware((to, from) => {
    if (process.client && useUserStore().user) {
        return navigateTo("/account/details");
    }
});
